import $ = require("jquery");
import Marionette = require("backbone.marionette");
import template = require("../templates/tabs-template");
import Portal = require("portal-gis");
import Utils = require("../utils");
import resx = require("../i18n/common");
import TabsItemCollection = require("../collections/tabs-collection");
import _ = require("underscore");
import Base = require("./base-view");

let hackCounter = 0;

class View extends Base<any> {
  private hasRendered: boolean;

  private TabStore: TabsItemCollection;

  static about = `
The app/controls/tabs uses this view to render controls in a tabbed container.
    `;

  execute(options) {
    _.defaults(options, {
      template: template,
    });

    this.TabStore = new TabsItemCollection();

    return super.execute(options);
  }

  onDestroy() {
    // need to remove collection callbacks?
  }

  onRender() {
    if (!this.hasRendered) {
      this.hasRendered = true;

      this.collection.on("add", (model: Backbone.Model, collection, options) => {
        console.log("adding new tab");
        let r = <Array<HTMLElement>>(<any>$(template({ items: [model] })));
        let body = model.get("body");
        if (typeof body === "string") {
          body = $(`<div class="collection-add-hack">${body}</div>`);
        } else {
          body = $(body);
        }
        $(r[1]).empty().append(body).appendTo(this.$el);
      });
    }
  }

  addTab(control: Portal.ControlLeaf, options: { body: JQuery }) {
    // provision for simple text+body control
    if (!control.Options) {
      control.id = control.id || _.uniqueId("tab");
      control.Options = { Values: [] };
    }

    // the body may be a jQuery element or HTML
    var model = this.TabStore.merge({
      id: control.id + "_" + hackCounter++,
      text: control.text || control.id,
      body: <any>options.body, // expects a string?
    });

    model.on("change", () => {
      // body should be a view otherwise potential memory leaks (but should be a temporary control)
      var values = <Rhythm.GIS.Dictionary<string>>(<any>model.changed);
      Utils.ifOption(values, "body", (body) => this.$el.find(`#tabregion-${control.id}`).html(body));
      Utils.ifOption(values, "text", (text) => this.$el.find(`a[href='#tabbody-${control.id}']`).html(text));
    });

    this.collection.add(<any>model);
  }
}

export = View;
